import { SATISFACTION_RATING_OPTIONS } from '../RatingRequest/constants';
import { RatingsType } from '../RatingRequest/types';

export const GREAT_FEEDBACK = (
  <>
    That’s nice to hear! Feel free to <strong>drop us a line</strong> about what made this a great
    experience.
  </>
);

export const POOR_FEEDBACK =
  "I'm sorry to hear that. Carvana values your feedback. What can we be doing better?";

export const AVERAGE_FEEDBACK =
  'Thanks for responding. Let us know if there is anything we can be doing better.';

export const PLACEHOLDER_TEXT = 'Write your feedback here...';

export const FEEDBACK_RESPONSES: { [key in RatingsType]: JSX.Element | string } = {
  [SATISFACTION_RATING_OPTIONS.POOR]: POOR_FEEDBACK,
  [SATISFACTION_RATING_OPTIONS.AVERAGE]: AVERAGE_FEEDBACK,
  [SATISFACTION_RATING_OPTIONS.GREAT]: GREAT_FEEDBACK,
};
